import { useMutation } from "@tanstack/react-query";
import { resetLocalPasswordAdminPortal } from "../services/AccountService";

export function useResetLocalPasswordAdminPortal() {
    return useMutation({
        mutationFn: resetLocalPasswordAdminPortal,
    });
}
